import {
  AfterViewInit,
  Component,
  HostBinding,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  inject
} from '@angular/core';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import {
  IGridEditDoneEventArgs, IGridEditEventArgs, IgxColumnComponent, IgxExcelExporterService, IgxPdfExporterService,
  IgxGridCell, IgxGridStateDirective, RowType
} from '@infragistics/igniteui-angular/grids/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import {
  IGX_INPUT_GROUP_DIRECTIVES,
  IgxInputGroupComponent,
  IgxSuffixDirective
} from '@infragistics/igniteui-angular/input-group';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import {ClsConfig} from '../../../util/cls-config';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {ClsUtil} from '../../../util/cls-util';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {ClsObjCrudCatalogos} from '../../../clases-pu/02-catalogos/cls-obj-crud-catalogos';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {INeodataGridCell, INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {EnumMCGenerales} from '../../../core/models/enum/enum-menu-contextual';
import {TresPuntosComponent} from '../../util/controles/tres-puntos/tres-puntos.component';
import {EnumNombresGrids} from '../../../core/models/enum/enum-nombres-grids';
import {ClsObjConfiguracionGrid} from '../../../clases-pu/util/cls-obj-configuracion-grid';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {EnumTresPuntos} from '../../../core/models/enum/enum-tres-puntos';
import {DetallePegadoComponent} from '../../util/ventanas/detalle-pegado/detalle-pegado.component';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {ClsObjCopiado} from '../../../clases-pu/01-presupuesto/copiado/cls-obj-copiado';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {ClsObjPegado} from '../../../clases-pu/99-herramientas/pegado/cls-obj-pegado';
import {TranslateModule} from '@ngx-translate/core';
import {ContextMenuGenericoComponent} from '../../util/controles/context-menu-generico/context-menu-generico.component';
import {UppercaseDirective} from '../../../core/directivas/uppercase.directive';
import {FormsModule} from '@angular/forms';
import {PasteHandlerNeodataDirective} from '../../../core/directivas/paste-handler-neodata.directive';
import {ClsCiudades, ClsProveedores} from 'src/app/core/models/cls-catalogos';
import {ClsColDetallePegado} from 'src/app/core/models/cls-pegado';
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../core/pipes/summary-pipe-neo.pipe";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";

@Component({
  selector: 'app-proveedores',
  templateUrl: './proveedores.component.html',
  styleUrls: ['./proveedores.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    MasOpcionesGridComponent,
    PasteHandlerNeodataDirective,
    IGX_INPUT_GROUP_DIRECTIVES,
    FormsModule,
    UppercaseDirective,
    IgxTextSelectionDirective,
    IgxFocusDirective,
    IgxButtonModule,
    IgxButtonDirective,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    IgxRippleModule,
    IgxRippleDirective,
    ContextMenuGenericoComponent,
    SummaryPipeNeoPipe,
    IgxInputGroupComponent,
    IgxSuffixDirective
  ],
  providers: [SummaryPipeNeoPipe]
})
export class ProveedoresComponent extends ClsConfig implements OnInit, AfterViewInit {
  private infPpto = inject(AppPresupuestosService);
  private tipoMsg = inject(TipoMensajesService);
  private summaryPipe = inject(SummaryPipeNeoPipe);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridProveedores', {read: IgxGridComponent, static: true})
  public gridProveedores: IgxGridComponent;
  @ViewChild('masOpcionesG', {read: MasOpcionesGridComponent, static: true})
  public masOpcionesG: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;
  @Input()
  public modoEdicion = true;
  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  public tresPuntosCiudad: TresPuntosComponent;

  public errorAlCargar: boolean;
  public dataProveedores: ClsProveedores[] = [];
  public activarBotones = false;
  // mostrar actionStrip
  public showActionStrip = true;
  // clase catalogos
  public mObjCRUDCatalogos: ClsObjCrudCatalogos = new ClsObjCrudCatalogos();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjCopiado: ClsObjCopiado = new ClsObjCopiado();
  private mObjPegado: ClsObjPegado = new ClsObjPegado();
  // menucontextual
  public verContextMenu = false;
  public contextmenuX = 0;
  public contextmenuY = 0;
  public cellMenuContextaul: IgxGridCell;
  public menus: INeodataMenu[] = [];
  public lengthMenu: number;
  public subMenusOpciones: any[];
  public sizeMenu = '';
  // CONFIGGRIDS: definir cada ng-Template que tengamos en el HTML
  @ViewChild('proveedorHeaderTemplate', {static: true}) public proveedorHeaderTemplate: TemplateRef<any>;
  @ViewChild('proveedorEditorTemplate', {static: true}) public proveedorEditorTemplate: TemplateRef<any>;
  @ViewChild('descripcionCiudadEditorTemplate', {static: true}) public descripcionCiudadEditorTemplate: TemplateRef<any>;
  @ViewChild('razonSocialHeaderTemplate', {static: true}) public razonSocialHeaderTemplate: TemplateRef<any>;
  @ViewChild('razonSocialEditorTemplate', {static: true}) public razonSocialEditorTemplate: TemplateRef<any>;
  @ViewChild('rfcProveedorEditorTemplate', {static: true}) public rfcProveedorEditorTemplate: TemplateRef<any>;
  @ViewChild('direccionProveedorEditorTemplate', {static: true}) public direccionProveedorEditorTemplate: TemplateRef<any>;
  @ViewChild('coloniaProveedorEditorTemplate', {static: true}) public coloniaProveedorEditorTemplate: TemplateRef<any>;
  @ViewChild('cpProveedorditorTemplate', {static: true}) public cpProveedorditorTemplate: TemplateRef<any>;
  @ViewChild('telefonoProveedorEditorTemplate', {static: true}) public telefonoProveedorEditorTemplate: TemplateRef<any>;
  @ViewChild('faxProveedorEditorTemplate', {static: true}) public faxProveedorEditorTemplate: TemplateRef<any>;
  @ViewChild('mailProveedorEditorTemplate', {static: true}) public mailProveedorEditorTemplate: TemplateRef<any>;
  @ViewChild('contactoProveedorEditorTemplate', {static: true}) public contactoProveedorEditorTemplate: TemplateRef<any>;
  @ViewChild('observacionesProveedorEditorTemplate', {static: true}) public observacionesProveedorEditorTemplate: TemplateRef<any>;
  @ViewChild('celularProveedorEditorTemplate', {static: true}) public celularProveedorEditorTemplate: TemplateRef<any>;
  @ViewChild('paginaWebProveedorEditorTemplate', {static: true}) public paginaWebProveedorEditorTemplate: TemplateRef<any>;
  @ViewChild(IgxGridStateDirective, {static: true}) public state;
  // Grid Layout
  public mObjConfigGrids: ClsObjConfiguracionGrid = new ClsObjConfiguracionGrid();
  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  public vtnGenerico: VtnGenericaComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridProveedores.data = [];
  }

  public ngAfterViewInit() {
    // se genera la plantilla default del grid
    const stateDefault = this.state.getState(true);

    this.mObjConfigGrids.saveGridState(EnumNombresGrids.Proveedores, true, stateDefault, '', this.clicked);
    const state = this.mObjConfigGrids.initGridState(EnumNombresGrids.Proveedores);
    if (!ClsUtil.esNulo(state[0])) {
      this.state.setState(state[0]);
    }
    this.clicked = state[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public onColumnInit(column: IgxColumnComponent) {
    switch (column.field) {
      case 'Proveedor':
        column.headerTemplate = this.proveedorHeaderTemplate;
        column.inlineEditorTemplate = this.proveedorEditorTemplate;
        break;
      case 'DescripcionCiudad':
        column.inlineEditorTemplate = this.descripcionCiudadEditorTemplate;
        column.summaries = this.summaryPipe.transform('filasSummary');
        break;
      case 'RazonSocial':
        column.headerTemplate = this.razonSocialHeaderTemplate;
        column.inlineEditorTemplate = this.razonSocialEditorTemplate;
        break;
      case 'RfcProveedor':
        column.inlineEditorTemplate = this.rfcProveedorEditorTemplate;
        break;
      case 'DireccionProveedor':
        column.inlineEditorTemplate = this.direccionProveedorEditorTemplate;
        break;
      case 'ColoniaProveedor':
        column.inlineEditorTemplate = this.coloniaProveedorEditorTemplate;
        break;
      case 'CodigoPostalProveedor':
        column.inlineEditorTemplate = this.cpProveedorditorTemplate;
        break;
      case 'TelefonoProveedor':
        column.inlineEditorTemplate = this.telefonoProveedorEditorTemplate;
        break;
      case 'FaxProveedor':
        column.inlineEditorTemplate = this.faxProveedorEditorTemplate;
        break;
      case 'MailProveedor':
        column.inlineEditorTemplate = this.mailProveedorEditorTemplate;
        break;
      case 'ContactoProveedor':
        column.inlineEditorTemplate = this.contactoProveedorEditorTemplate;
        break;
      case 'ObservacionesProveedor':
        column.inlineEditorTemplate = this.observacionesProveedorEditorTemplate;
        break;
      case 'CelularProveedor':
        column.inlineEditorTemplate = this.celularProveedorEditorTemplate;
        break;
      case 'PaginaWebProveedor':
        column.inlineEditorTemplate = this.paginaWebProveedorEditorTemplate;
        break;
    }
    // column.cellClasses = this.backgroundClasses;
  }

  public async cargarProveedores() {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        this.mObjCRUDCatalogos.dataCatalogo = [];
        this.dataProveedores = [];
        await this.mObjCRUDCatalogos.obtenerCatalogo(0, 'ConsultarProveedores2021');
        this.mObjCRUDCatalogos.dataCatalogo.forEach(item => {
          const prov: ClsProveedores = {
            IdProveedor: item.IdProveedor,
            Proveedor: item.Proveedor,
            IdCiudad: item.IdCiudad,
            DescripcionCiudad: item.Ciudad.Ciudad,
            RazonSocial: item.RazonSocial,
            RfcProveedor: item.RfcProveedor,
            DireccionProveedor: item.DireccionProveedor,
            ColoniaProveedor: item.ColoniaProveedor,
            CodigoPostalProveedor: item.CodigoPostalProveedor,
            TelefonoProveedor: item.TelefonoProveedor,
            FaxProveedor: item.FaxProveedor,
            MailProveedor: item.MailProveedor,
            ContactoProveedor: item.ContactoProveedor,
            ObservacionesProveedor: item.ObservacionesProveedor,
            CelularProveedor: item.CelularProveedor,
            PaginaWebProveedor: item.PaginaWebProveedor,
            ProveedorDefault: item.ProveedorDefault
          };
          this.dataProveedores.push(prov);
        });
        this.gridProveedores.data = this.dataProveedores;
        this.errorAlCargar = false;
        this.tipoMsg.cerrarWaitDialog();
      } catch (e) {
        this.tipoMsg.cerrarWaitDialog();
        this.errorAlCargar = true;
        this.tipoMsg.mostrarMsg(e.message, 'error');
      }
    }
  }

  public menuContextual(evt: any) {
    evt.event.preventDefault();
    this.disableContextMenu();
    this.disableAllContextMenu();
    this.menus = this.mObjCRUDCatalogos.crearMenuContextual({
      esCliente: false,
      esUnidad: false,
      esEmpresa: false
    }, this.infPpto.esPptoMaestro);
    this.subMenusOpciones = [];
    this.lengthMenu = this.menus.filter(x => !x.disabled).length;
    this.contextmenuX = ClsUtil.calcPosition(document.body.clientWidth, evt.event.clientX, true, this.lengthMenu);
    this.contextmenuY = ClsUtil.calcPosition(document.body.clientHeight, evt.event.clientY, false, this.lengthMenu);
    this.sizeMenu = (this.lengthMenu * 37) + 'px';
    this.cellMenuContextaul = evt.cell;
    this.verContextMenu = true;
  }

  public disableContextMenu() {
    if (this.verContextMenu) {
      this.verContextMenu = false;
    }
  }

  public disableAllContextMenu() {
    this.mObjGenerico.disableAllContextMenu(this.infPpto);
  }

  public async accionSeleccionada(evt: INeodataGridCell) {
    try {
      switch (evt.accionMenu.id) {
        case EnumMCGenerales.Copiar:
          await this.copiarData();
          break;
        case EnumMCGenerales.Pegar:
          let data: any = await navigator.clipboard.readText().then((data2) => data2);
          data = this.pasteHandlerNeo.processData(data);
          await this.datosPegadosDesdeExcel(data);
          break;
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMCGenerales.GuardarLayout:
          const state = this.state.getState(true);
          this.mObjConfigGrids.saveGridState(EnumNombresGrids.Proveedores, false, '', state, !this.clicked);
          break;
        case EnumMCGenerales.ReestablecerLayout:
          this.restoreGrid();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public restoreGrid() {
    const stateDefault = this.mObjConfigGrids.restoreGrid(EnumNombresGrids.Proveedores);
    if (!ClsUtil.esNulo(stateDefault[0])) {
      this.state.setState(stateDefault[0]);
    }
    this.clicked = stateDefault[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridProveedores.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridProveedores.filteringLogic = FilteringLogic.Or;
    this.gridProveedores.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public rowEditEnter() {
    this.showActionStrip = false;
  }

  public rowEditExit() {
    this.showActionStrip = true;
  }

  // evento que se ocupa para guardar o modificar
  public async addUpdateProveedor(proveedor: IGridEditDoneEventArgs) {
    const newValor: ClsProveedores = proveedor.newValue;
    const oldValor: ClsProveedores = proveedor.oldValue;
    if (!ClsUtil.esNulo(this.tresPuntosCiudad)) {
      newValor.IdCiudad = this.tresPuntosCiudad.idDefault;
      newValor.DescripcionCiudad = this.tresPuntosCiudad.valorDefault;
    }
    if (proveedor.isAddRow) {
      await this.agregarModificarProveedor(newValor, oldValor, proveedor.isAddRow);
    } else {
      // al editar los campos, validar que sean distintos para ocupar el servicio
      if (this.mObjCRUDCatalogos.validarSiCambioCamposCatalogos(newValor, oldValor, EnumTresPuntos.Proveedores)) {
        await this.agregarModificarProveedor(newValor, oldValor, proveedor.isAddRow);
      }
    }
  }

  private async agregarModificarProveedor(newProveedor: ClsProveedores, oldProveedor: ClsProveedores, isAddRow: boolean) {
    let respuesta: bigint;
    const objCatalogo: ClsProveedores = new ClsProveedores();
    try {
      objCatalogo.IdProveedor = isAddRow ? ClsUtil.parseJSONBig(0) : newProveedor.IdProveedor;
      objCatalogo.CelularProveedor = newProveedor.CelularProveedor;
      objCatalogo.CodigoPostalProveedor = newProveedor.CodigoPostalProveedor;
      objCatalogo.ColoniaProveedor = newProveedor.ColoniaProveedor;
      objCatalogo.ContactoProveedor = newProveedor.ContactoProveedor;
      objCatalogo.DireccionProveedor = newProveedor.DireccionProveedor;
      objCatalogo.FaxProveedor = newProveedor.FaxProveedor;
      objCatalogo.IdCiudad = newProveedor.IdCiudad;
      objCatalogo.MailProveedor = newProveedor.MailProveedor;
      objCatalogo.ObservacionesProveedor = newProveedor.ObservacionesProveedor;
      objCatalogo.PaginaWebProveedor = newProveedor.PaginaWebProveedor;
      objCatalogo.Proveedor = newProveedor.Proveedor.toUpperCase();
      objCatalogo.ProveedorDefault = newProveedor.ProveedorDefault;
      objCatalogo.RazonSocial = newProveedor.RazonSocial;
      objCatalogo.RfcProveedor = newProveedor.RfcProveedor;
      objCatalogo.TelefonoProveedor = newProveedor.TelefonoProveedor;
      this.tipoMsg.mostrarWaitDialog(isAddRow ? 'MENSAJES.WAIT.GUARDANDO_CATALOGO' : 'MENSAJES.WAIT.MODIFICANDO_CATALOGO');
      respuesta = await this.mObjCRUDCatalogos.agregarModificarCatalogo([objCatalogo], 'ProveedoresRegistraActualiza2021');
      if (isAddRow) {
        newProveedor.IdProveedor = respuesta;
      }
      this.tipoMsg.mostrarToast(isAddRow ? 'MENSAJES.TOAS.GUARDANDO_CATALOGO' : 'MENSAJES.TOAS.MODIFICANDO_CATALOGO');
      this.tresPuntosCiudad = undefined;
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.cancelarAddUpdateProveedores(newProveedor, oldProveedor, isAddRow);
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa cuando manda error al intentar agregar o modificar,
  // al agregar si manda error se quita la fila del grid
  // al editar si manda error se regresa a los valores anteriores
  private cancelarAddUpdateProveedores(newProveedor: ClsProveedores, oldProveedor: ClsProveedores, isAddRow: boolean) {
    if (isAddRow) {
      this.gridProveedores.deleteRowById(newProveedor.IdProveedor);
    } else {
      this.gridProveedores.updateRow(oldProveedor, oldProveedor.IdProveedor);
    }
    this.tresPuntosCiudad = undefined;
  }

  private async eliminarProveedor(rowContext: RowType) {
    const proveedor: ClsProveedores = rowContext.data;
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.ELIMINANDO_CATALOGO', undefined, 'delete');
      await this.mObjCRUDCatalogos.eliminarCatalogo(proveedor.IdProveedor, 'EliminarProveedores2021');
      this.gridProveedores.getRowByIndex(rowContext.index).delete();
      this.tipoMsg.mostrarToast('MENSAJES.TOAS.ELIMINANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa el evento rowEdit para validar uno o varios campos obligatorios,
  // si falta algun campo de toda la fila se cancela la edicion y se manda mensaje de que campos faltan
  // en caso de ser todo OK, procede al agregado o modificado
  public validarProveedor(proveedor: IGridEditEventArgs) {
    const valor: ClsProveedores = proveedor.newValue;
    proveedor.cancel = this.esValido(valor, proveedor, proveedor.isAddRow);
  }

  // en este caso se pasa el valor de la unidad, ya que es el unico campo obligatorio,
  // en caso de ser mas campos a validar, pasar toda la clase
  private esValido(proveedores: ClsProveedores, prov: any, isAddRow: boolean): boolean {
    // validar campos obligatorios
    if (ClsUtil.esNulo(proveedores.Proveedor)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.PROVEEDOR.COL_PROVEEDOR')));
      return true;
    }

    if (ClsUtil.esNulo(proveedores.RazonSocial)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.PROVEEDOR.COL_RS')));
      return true;
    }
    // valida si ya existe la empresa cuando se agrega o modifica
    if (isAddRow) {
      if (this.dataProveedores.findIndex(proveedor => proveedor.Proveedor === proveedores.Proveedor) !== -1) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(proveedores.Proveedor));
        return true;
      }
    } else {
      if (proveedores.Proveedor !== prov.oldValue.Proveedor) {
        if (this.dataProveedores.findIndex(proveedor => proveedor.Proveedor === proveedores.Proveedor) !== -1) {
          this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(proveedores.Proveedor));
          return true;
        }
      }
    }
    return false;
  }

  public accionStripRowBtn(rowContext: RowType, indexBtn: number) {
    try {
      switch (indexBtn) {
        case 1:
          this.beginAddRowByIndexNeo(this.gridProveedores, rowContext.index);
          break;
        case 2:
          this.tipoMsg.mostrarQuestion((resp: boolean) => {
            if (resp) {
              this.eliminarProveedor(rowContext);
            }
          }, this.mObjGenerico.getTranslationsQuestionBorrar(rowContext.data.Proveedor));
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridProveedores, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.PROVEEDORES'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridProveedores.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridProveedores,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.PROVEEDORES'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarProveedores();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onOpen(input: HTMLInputElement, data: ClsProveedores) {
    const selectRows: any = [this.tresPuntosCiudad?.idDefault];
    this.tresPuntosCiudad = this.crearCompDinamico.crearComponente(TresPuntosComponent).instance as TresPuntosComponent;
    this.tresPuntosCiudad.tipoCatalogo = EnumTresPuntos.Ciudades;
    this.tresPuntosCiudad.selectedRows = selectRows;
    await this.tresPuntosCiudad.onOpen();
    this.tresPuntosCiudad.eventFilaSeleccionada.subscribe((valor: ClsCiudades) => {
      input.value = valor.Ciudad;
      this.gridProveedores.updateCell(valor.Ciudad.toUpperCase(), data.IdProveedor, 'DescripcionCiudad');
      setTimeout(() => {
        input.focus();
      }, 5);
    });
  }

  public handleRowSelection() {
    this.gridProveedores.nativeElement.focus();
  }

  public async datosPegadosDesdeExcel(datosPegado: any[]) {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.PEGANDO');
      let arrayProv: ClsProveedores[] = [];
      let dataDetalle: ClsColDetallePegado[];
      const colProv: string[] =
        [this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_PROVEEDOR'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_CIUDAD'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_RS'),
          'RFC',
          this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_DIRECCION'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_COLONIA'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_CP'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_TELEFONO'),
          'Fax',
          'Mail',
          this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_CONTACTO'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_OBS'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_CELULAR'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_PAGINA'),
          this.mObjGenerico.getTranslationsSubject('GRIDS.PROVEEDOR.COL_PROV_DEFAULT')];
      this.mObjCopiado.columnasRequeridas = [colProv[0], colProv[2]];
      if (this.mObjCopiado.validarCamposRequeridos(datosPegado)) {
        let datos = this.mObjCopiado.procesarDatos(datosPegado, true);
        datos = this.mObjPegado.mergeDescriptions(datos, EnumNombresGrids.Proveedores);
        dataDetalle = this.mObjPegado.verificarDetallePegado(datos, colProv, [colProv[0], colProv[2]], EnumNombresGrids.Proveedores, this.mObjGenerico);
        if (dataDetalle.length > 0) {
          const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
          vtnGenerico.queVtnEstaAbierta = 'PegadoEspecial';
          const vtnDiferencia = vtnGenerico.crearComponente(DetallePegadoComponent);
          vtnDiferencia.dataDetalle = dataDetalle;
          vtnDiferencia.open();
        } else {
          datos.forEach(x => {
            const valProv: any[] = [
              (x[colProv[0]] as string).toUpperCase(),
              ClsUtil.cadenaX(x[colProv[1]] as string).toUpperCase(),
              ClsUtil.cadenaX(x[colProv[2]] as string).toUpperCase(),
              ClsUtil.cadenaX(x[colProv[3]] as string),
              ClsUtil.cadenaX(x[colProv[4]] as string),
              ClsUtil.cadenaX(x[colProv[5]] as string),
              ClsUtil.cadenaX(x[colProv[6]] as string),
              ClsUtil.cadenaX(x[colProv[7]] as string),
              ClsUtil.cadenaX(x[colProv[8]] as string),
              ClsUtil.cadenaX(x[colProv[9]] as string),
              ClsUtil.cadenaX(x[colProv[10]] as string),
              ClsUtil.cadenaX(x[colProv[11]] as string),
              ClsUtil.cadenaX(x[colProv[12]] as string),
              ClsUtil.cadenaX(x[colProv[13]] as string),
              x[colProv[14]] === '1'];
            // Boolean(Number(x[colProv[14]]))];
            const resp: any = this.mObjCRUDCatalogos.crearObjCatalogos(this.dataProveedores, valProv, colProv, EnumTresPuntos.Proveedores, this.mObjGenerico);
            if (!ClsUtil.esNulo(resp.esNuevo)) {
              if (resp.esNuevo) {
                arrayProv.push(resp.obj);
              } else {
                this.gridProveedores.updateCell(valProv[0], resp.obj.IdProveedor, 'Proveedor');
                this.gridProveedores.updateCell(valProv[1], resp.obj.IdProveedor, 'DescripcionCiudad');
                this.gridProveedores.updateCell(valProv[2], resp.obj.IdProveedor, 'RazonSocial');
                this.gridProveedores.updateCell(valProv[3], resp.obj.IdProveedor, 'RfcProveedor');
                this.gridProveedores.updateCell(valProv[4], resp.obj.IdProveedor, 'DireccionProveedor');
                this.gridProveedores.updateCell(valProv[5], resp.obj.IdProveedor, 'ColoniaProveedor');
                this.gridProveedores.updateCell(valProv[6], resp.obj.IdProveedor, 'CodigoPostalProveedor');
                this.gridProveedores.updateCell(valProv[7], resp.obj.IdProveedor, 'TelefonoProveedor');
                this.gridProveedores.updateCell(valProv[8], resp.obj.IdProveedor, 'FaxProveedor');
                this.gridProveedores.updateCell(valProv[9], resp.obj.IdProveedor, 'MailProveedor');
                this.gridProveedores.updateCell(valProv[10], resp.obj.IdProveedor, 'ContactoProveedor');
                this.gridProveedores.updateCell(valProv[11], resp.obj.IdProveedor, 'ObservacionesProveedor');
                this.gridProveedores.updateCell(valProv[12], resp.obj.IdProveedor, 'CelularProveedor');
                this.gridProveedores.updateCell(valProv[13], resp.obj.IdProveedor, 'PaginaWebProveedor');
                this.gridProveedores.updateCell(valProv[14], resp.obj.IdProveedor, 'ProveedorDefault');
                arrayProv.push(resp.obj);
              }
            }
          });
          // invocar servicio para agregar o modificar siempre y cuando el arrayUnidades tenga valor
          if (arrayProv.length > 0) {
            const respuesta: any = await this.mObjCRUDCatalogos.agregarModificarCatalogo(arrayProv, 'ProveedoresRegistraActualizaCod', false);
            // consultar catalogo
            // n_n
            // filtro los registros con id 0
            arrayProv = arrayProv.filter(value => value.IdProveedor === BigInt(0));
            // iteramos la respuesta para ir asignando los ids para los registros nuevos
            const key: string[] = Object.keys(respuesta);
            key.forEach(x => {
              const prov: ClsProveedores = arrayProv.find(value1 => value1.Proveedor === x);
              if (!ClsUtil.esNulo(prov)) {
                prov.IdProveedor = ClsUtil.bigintX(respuesta[x]);
                this.gridProveedores.addRow(prov);
              }
            });
          }
        }
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public async customKeydown(eventArgs) {
    const ctrl = eventArgs.ctrlKey;
    const key = eventArgs.keyCode;
    // Ctrl-C ||  Cmd-C
    if ((ctrl || eventArgs.metaKey) && key === 67) {
      await this.copiarData();
    }
  }

  public async copiarData() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.COPIANDO');
      const msg: string = await ClsUtil.copiarDatosGrids(this.gridProveedores, 'IdProveedor', this.mObjGenerico);
      msg && this.tipoMsg.mostrarToast(msg);
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public clearProps() {
    this.gridProveedores.clearSort();
    this.gridProveedores.clearFilter();
    this.gridProveedores.clearSearch();
    this.gridProveedores.deselectAllRows();
    this.clearInput();
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridProveedores.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridProveedores.getRowData(rowSeleccionados[0]);
      this.gridProveedores.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
